let gameData = [];

gameData = [
        {
            title: "Worldometers",
            description: "See everyone on the world on the same page!",
            link: "https://www.worldometers.info/watch/world-population/"
        },
        {
            title: "This is Sand",
            description: "Play with some virtual sand!",
            link: "https://thisissand.com/"
        },
        {
            title: "Toilet Paper",
            description: "Waste all the toilet paper you want with this fun website!",
            link: "https://papertoilet.com/"
        },
        {
            title: "Wordle",
            description: "Play the world-famous Wordle Game.",
            link: "https://www.nytimes.com/games/wordle/index.html"
        },
        {
            title: "Sometimes Red, Sometimes Blue",
            description: "This website is sometimes red and sometimes blue (refresh to change the color).",
            link: "https://www.sometimesredsometimesblue.com/"
        },
        {
            title: "Neal Fun",
            description: "See a variety of fun games created by Neal, including games that teach you about things like our atmosphere, the universe, and more!",
            link: "https://neal.fun/"
        },
        {
            title: "Google Doodles",
            description: "See all of the Google Doodles! See the creative drawings and games of the Google team, seen by millions around the world!",
            link: "https://www.google.com/doodles"
        },
        {
            title: "Valentine's Day 2017 google doodle",
            description: "See the google doodle for Valentine's Day 2017, a fun game where you play as a pangolin!",
            link: "https://www.google.com/doodles/valentines-day-2017-day-1"
        },
        {
            title: "Halloween 2016 google doodle",
            description: "See the google doodle for Halloween 2016, a game where you play as a cute black cat!",
            link: "https://www.google.com/doodles/halloween-2016"
        },
        {
            title: "Chrome Dino",
            description: "Play the iconic chrome dino game and learn about its history!",
            link: "https://dino-chrome.com/"
        }
    ]


export default gameData;